import { Component, OnInit, Input } from '@angular/core';
import { Competition } from 'app/models/competition';
import slugify from 'slugify';

@Component({
  selector: 'app-competition-details',
  templateUrl: './competition-details.component.html',
  styleUrls: ['./competition-details.component.scss']
})
export class CompetitionDetailsComponent implements OnInit {

  @Input() competition: Competition;
  @Input() disabled: boolean;

  constructor() {
    this.disabled = false;
  }

  ngOnInit() {
  }

  urlChanged() {
    this.competition.compUrl = slugify(this.competition.compUrl);
  }
}
